/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */

import {BgImage, DownloadIcon, HTick} from '@jobseeker/lotus/assets/icons';
import {AppStore, PlayStore, Premium} from '@jobseeker/lotus/assets/images';
import {getDevice, getRefTagAndOrigin} from './homeCategory';
import {
  handleTracking,
  TrackEventUBA,
  openUrl,
} from '@jobseeker/common-core/utils';
import {BlogMiddleBannerHP} from './Blog';
import React, {SetStateAction, useEffect, useState} from 'react';
import {Box, Button, styled, Typography, useMediaQuery} from '@mui/material';
import {getQueryParamsAndSeekerId} from './homePageJobs';
import {useSelector} from 'react-redux';
import {AppState} from '@jobseeker/common-core/types';
import {Image} from '@jobseeker/lotus/components/Image';

const PLAYSTORE_URL =
  'https://play.google.com/store/apps/details?id=com.hirist.jobseeker&hl=en_IN';
const APPSTORE_URL = 'https://apps.apple.com/in/app/hirist/id952697960';

interface HomePageCompanyIconsProps {
  isTechDrive: boolean;
  setLoginPopUp: (value: SetStateAction<boolean>) => void;
  blogs: object;
}
const StyledButton = styled(Button)({
  borderRadius: '4px',
  boxShadow: '0 4px 21px 0 rgba(0, 0, 0, 0.19)',
  backgroundColor: '#ffffff',
  color: '#e9630c !important',
  fontSize: '20px',
  padding: '17px',
  paddingLeft: '51px',
  paddingRight: '51px',
  lineHeight: '27px',
  textAlign: 'center',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#ffffff',
  },
});
export const Static: React.FC<HomePageCompanyIconsProps> = ({
  isTechDrive,
  setLoginPopUp,
  blogs,
}) => {
  const {userId, isLoggedIn} = useSelector((state: AppState) => state.auth);

  const handleUbaTracking = (eventName: any, section: string) => {
    const {queryParams} = getQueryParamsAndSeekerId();
    TrackEventUBA(eventName, 'click', {
      ref: queryParams.ref || '',
      page: 'jsHomePage',
      section,
      sessionUsername: userId ? userId.toString() : '',
    });
  };
  const isnotMob = useMediaQuery('(min-width:769px)');
  const onClickAppStoreLink = () => {
    const {origin, refText} = getRefTagAndOrigin();
    handleTracking(
      'jsClickMobileAppLinkage',

      {
        event_category: 'CallOuts',
        Origin: 'HomePage',
        Device: sessionStorage.getItem('device') || 'desktop',
        UserId: 0,
        Status: 'LoggedOut',
      }
    );
    handleTracking(
      'jsClickIOSApp',

      {
        event_category: 'jsHomePage',
        Source: `${origin}`,
        Device: sessionStorage.getItem('device') || 'desktop',
        Ref: `${refText}`,
      }
    );

    handleUbaTracking('jsHomePageClick', 'iOS');
  };
  const useUserAgent = () => {
    const [userAgent, setUserAgent] = useState<string>('');

    useEffect(() => {
      if (typeof navigator !== 'undefined') {
        setUserAgent(navigator.userAgent || navigator.vendor || '');
      }
    }, []);

    return userAgent;
  };
  const userAgent = useUserAgent();
  const device = getDevice(userAgent);

  const onClickPlayStoreLink = () => {
    const {origin, refText} = getRefTagAndOrigin();
    handleTracking(
      'jsClickMobileAppLinkage',

      {
        event_catergory: 'CallOuts',
        Origin: 'HomePage',
        Device: sessionStorage.getItem('device') || 'desktop',
        Type: 'Android',
        Status: 'LoggedOut',
      }
    );
    handleTracking(
      'jsClickAndroidApp',

      {
        event_category: 'jsHomePage',
        Source: `${origin}`,
        Device: sessionStorage.getItem('device') || 'desktop',
        Ref: `${refText}`,
      }
    );

    handleUbaTracking('jsHomePageClick', 'Android');

    // window.location.href = PLAYSTORE_URL;
  };

  const onClickRegisterBtn = (openLoginPopup: any) => {
    setTimeout(() => {
      const {origin, refText} = getRefTagAndOrigin();
      handleTracking('jsClickRegister', {
        event_category: 'jsHomePage',
        Source: `${origin}`,
        Device: sessionStorage.getItem('device') || 'desktop',
        Ref: `${refText}`,
      });
      handleUbaTracking('jsHomePageClick', 'RegisterNow');
      openLoginPopup();
      setLoginPopUp(true);
    }, 0);
  };
  return (
    <Box sx={{width: '100%', paddingTop: {xxs: '100px', md: '25px'}}}>
      {/* Download App Section */}
      <Box
        display={{md: 'flex', xxs: 'inline'}}
        sx={{
          width: '100%',
          alignItems: 'center',
          paddingBottom: '92px',
          marginTop: {xxs: '150px', md: '0px'},
        }}
      >
        <Box
          sx={{
            width: {xxs: '100%', md: '40%'},
            paddingLeft: {xxs: '15px', md: '69px'},
            paddingRight: {xxs: '15px', md: 0},
            marginRight: {xxs: 0, md: '71px'},
            paddingTop: {xxs: 0, md: '0px'},
            textAlign: {xxs: 'center', md: 'left'},
            display: 'inline-block',
          }}
        >
          <Image
            src={Premium}
            width="30"
            height="30"
            alt="prem"
            style={{marginLeft: isnotMob ? '-20px' : '-200px'}}
          />
          <Typography
            variant="h3"
            sx={{
              fontSize: {xxs: '24px', md: '38px'},
              mt: '-20px',
              fontWeight: 'bold',
              lineHeight: 1.37,
              color: '#000000',
              marginBottom: {xxs: '28px', md: '39px'},
              fontFamily: 'Nunito Sans',
            }}
          >
            Apply on the Go! <br />
            <Typography
              component="p"
              sx={{
                fontSize: {xxs: '24px', md: '38px'},
                fontWeight: 200,
                lineHeight: 1.37,
                color: '#000000',
                fontFamily: 'Nunito Sans',
              }}
            >
              Download the hirist App and get a seamless <br /> job-hunting
              experience.
            </Typography>
          </Typography>

          <Box
            component={Image}
            src={DownloadIcon}
            sx={{
              display: {xxs: 'block', md: 'none'},
              width: '100%',
              height: 'auto',
              aspectRatio: '67 / 75',
              marginBottom: '85px',
            }}
            alt="Download Icon"
          />

          {/* Features Section */}
          <Box
            sx={{minHeight: '300px', width: '100%'}}
            display={{xxs: 'flex', md: 'block'}}
            flexDirection={'column'}
            alignItems={{xxs: 'center', md: 'auto'}}
          >
            {[
              {
                title: 'Apply wherever you are, easily',
                description: 'Simple interface will guide your way.',
              },
              {
                title: 'Never miss out on any opportunity',
                description: 'Get notified on jobs relevant to you.',
              },
              {
                title: 'Stay updated, always',
                description:
                  'Track your application status and chat with recruiters on the go.',
              },
            ].map((feature, index) => (
              <Box
                key={index}
                sx={{
                  marginBottom: '52px',
                  maxWidth: {xxs: '320px', md: '100%'},
                  textAlign: {xxs: 'left', md: 'left'},
                  width: {xxs: '320px', md: 'auto'},
                }}
              >
                <Box display="flex" gap={{xxs: 3, md: 2}} width="100%">
                  <Box
                    component={Image}
                    src={HTick}
                    sx={{
                      width: '12px',
                      height: '12px',
                      marginTop: '8px',
                      flexShrink: 0,
                    }}
                    alt="Tick Icon"
                  />
                  <Box sx={{width: 'calc(100% - 40px)'}}>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: '18px',
                        fontWeight: 500,
                        color: '#000000',
                        marginBottom: '2px',
                        fontFamily: 'Nunito Sans',
                      }}
                    >
                      {feature.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: '16px',
                        fontWeight: 200,
                        color: '#000000',
                        fontFamily: 'Nunito Sans',
                      }}
                    >
                      {feature.description}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            ))}
          </Box>

          {/* App Buttons */}
          <Box sx={{height: '51px', marginBottom: {xxs: '85px', md: 0}}}>
            <Box
              component="a"
              onClick={e => {
                e.preventDefault();
                setTimeout(() => {
                  onClickAppStoreLink();
                  openUrl(APPSTORE_URL, '_self');
                }, 0);
              }}
              href={APPSTORE_URL}
              sx={{
                display: 'inline-block',
                cursor: 'pointer',
                marginRight: '6px',
                height: '51px',
              }}
            >
              <Box
                component={Image}
                src={AppStore as unknown as string}
                sx={{
                  width: {xxs: '145px', md: '157px'},
                  height: '100%',
                }}
                alt="iOS Logo"
              />
            </Box>
            <Box
              component="a"
              onClick={e => {
                e.preventDefault();
                setTimeout(() => {
                  onClickPlayStoreLink();
                  openUrl(PLAYSTORE_URL, '_self');
                }, 0);
              }}
              href={PLAYSTORE_URL}
              sx={{
                height: '51px',
                display: 'inline-block',
                cursor: 'pointer',
              }}
            >
              <Box
                component={Image}
                src={PlayStore as unknown as string}
                sx={{
                  width: {xxs: '127px', md: '139px'},
                  height: '100%',
                }}
                alt="Android Logo"
              />
            </Box>
          </Box>
        </Box>

        {/* Large Download Image */}
        <Box
          component={Image}
          src={DownloadIcon}
          sx={{
            display: {xxs: 'none', md: 'block'},
            width: '49%',
            verticalAlign: 'top',
          }}
          alt="Download Icon"
        />
      </Box>

      {/* Blog Middle Banner */}
      {!isTechDrive && <BlogMiddleBannerHP blogs={blogs} />}

      {/* Opportunities Section */}
      <Box
        sx={{
          position: 'relative',
          height: {xxs: '418px', md: '270px'},
          paddingLeft: {xxs: '30px', md: '69px'},
          paddingRight: {xxs: '24px', md: '71px'},
          paddingBottom: {xxs: '65px', md: 0},
          pt: {xxs: 1, md: 2, lg: 5},
        }}
      >
        <Box
          component={Image}
          src={BgImage}
          sx={{
            position: 'absolute',
            height: '100%',
            width: '100%',
            left: 0,
            backgroundColor: '#e9630c',
            zIndex: -1,
          }}
          alt="Static Background"
        />
        <Box
          sx={{
            width: {xxs: '100%', md: '49.3%'},
            display: 'inline-block',
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontSize: {xxs: '34px', md: '42px'},
              fontWeight: 200,
              lineHeight: {xxs: '48px', md: '57px'},
              color: '#ffffff',
              marginBottom: '11px',
              fontFamily: 'Nunito Sans',
              marginTop: {xxs: '32px', md: '32px'},
            }}
          >
            <b>Premium Handpicked </b>
            <br></br>Jobs for you
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: '18px',
              fontWeight: 300,
              lineHeight: 1.5,
              color: '#ffffff',
              fontFamily: 'Nunito Sans',
            }}
          >
            Premium Handpicked Jobs that you will not find anywhere else
          </Typography>
        </Box>
        <StyledButton
          sx={{
            float: {xxs: 'left', md: 'right'},
            marginTop: {xxs: '50px', md: '85px'},
          }}
          onClick={() => onClickRegisterBtn(() => {})}
        >
          Register Now!
        </StyledButton>
      </Box>
    </Box>
  );
};
